const generatedSubmissionFilePattern = /^submission-\d+-\d+(\.[^.]+)?$/i;
const mojibakeFileNamePattern = /[\u0080-\u009fÃÂâéèçåäöæ¼½¾]/;

const decodeMojibakeFileName = (fileName: string) => {
  if (!mojibakeFileNamePattern.test(fileName) || typeof TextDecoder === 'undefined') {
    return fileName;
  }

  try {
    const bytes = Uint8Array.from(fileName, (character) => character.charCodeAt(0) & 0xff);
    const decodedFileName = new TextDecoder('utf-8', { fatal: true }).decode(bytes);

    return decodedFileName || fileName;
  } catch {
    return fileName;
  }
};

export const getFileNameFromUrl = (fileUrl: string, index: number) => {
  const rawName = fileUrl.split('?')[0].split('/').pop() || '';
  const fileName = decodeMojibakeFileName(decodeURIComponent(rawName).trim());

  if (!fileName) {
    return `Uploaded file ${index + 1}`;
  }

  const extensionMatch = fileName.match(/\.[^.]+$/);
  if (generatedSubmissionFilePattern.test(fileName)) {
    return `Uploaded file ${index + 1}${extensionMatch?.[0] ?? ''}`;
  }

  return fileName;
};

export const getSubmissionFileDisplayNames = (
  fileUrls: string[],
  fileNames?: Array<string | null | undefined> | null,
) =>
  fileUrls.map((fileUrl, index) => {
    const originalFileName = fileNames?.[index]?.trim();

    return originalFileName
      ? decodeMojibakeFileName(originalFileName)
      : getFileNameFromUrl(fileUrl, index);
  });
